import React, { Fragment } from 'react'
import RichTextbox from '../../../../control/richTextEditor/richTextEditor'
import { Form, Field } from 'react-final-form'
import MyButton from '../../../../control/button/button'
import { FieldArray } from 'react-final-form-arrays'
import arrayMutators from 'final-form-arrays'
import { Grid } from '@material-ui/core'

let MyRichTextFieldView: React.FC<any> = ({ ...other }) => {
    return (
        <div>
            <Form
                onSubmit={(val) => {}}
                initialValues={{
                    myRichText: [
                        {
                            richtextObj: { contentHtml: '', contentText: '' },
                        },
                        {
                            richtextObj: { contentHtml: '', contentText: '' },
                        },
                    ],
                }}
                mutators={{
                    ...arrayMutators,
                }}
            >
                {({ handleSubmit, form }) => {
                    return (
                        <>
                            {/* <RichTextbox name={'myRichText'} /> */}

                            <FieldArray name="myRichText">
                                {({ fields }) =>
                                    fields.map((name, index) => (
                                        <Grid container item xs={12} key={name}>
                                            {/* <Grid container item xs={12} justify={'flex-end'}> */}
                                            <RichTextbox name={`${name}.richtextObj`} />
                                            {/* </Grid> */}
                                        </Grid>
                                    ))
                                }
                            </FieldArray>

                            <MyButton color="primary" onClick={handleSubmit}>
                                submit form
                            </MyButton>
                        </>
                    )
                }}
            </Form>
        </div>
    )
}

let MyRichTextFieldCtrl: React.FC<any> = ({
    handleValueChange,
    name,
    required,
    validates,
    maxLength,
    isDraftNotRequire,
    ...others
}) => {
    const richTextFieldModel = {} //useTextfield({})
    return (
        <MyRichTextFieldView
            maxLength={maxLength}
            required={required}
            handleValueChange={handleValueChange}
            {...richTextFieldModel}
            {...others}
        />
    )
}

export default MyRichTextFieldCtrl
